import { createApp, App as VueApp } from 'vue'
import GaragePartsCustomized from './GaragePartPicker/App.vue'

let vueApp: VueApp<Element> | null = null
let activeField: HTMLElement | null = null
let gravityForm: HTMLElement;
let currentButton: HTMLElement | null = null

function isInViewport(element: HTMLElement) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

function scrollIntoViewWithAdminBarOffsetIfNeeded(element: HTMLElement) {
	if (isInViewport(element)) {
		return;
	}

	const wpadminbar = document.getElementById('wpadminbar');
	let offset = 0;

	if (wpadminbar) {
		offset = wpadminbar.clientHeight;
	}

	const elementPosition = element.getBoundingClientRect().top;
	const offsetPosition = elementPosition + window.pageYOffset - offset;

	window.scrollTo({
		top: offsetPosition,
		behavior: "auto",
	});
}

let scrollY = window.scrollY;

function closePicker() {
	if (vueApp) {
		vueApp.unmount()
	}

	const overlay = gravityForm.querySelector('.gc-gform-overlay')

	if (overlay) {
		overlay.remove();
	}

	window.scrollTo(window.scrollX, scrollY);

	if (activeField) {
		scrollIntoViewWithAdminBarOffsetIfNeeded(activeField);
		activeField = null;
	}
}

function openPicker() {
	if (null === currentButton) {
		return;
	}

	scrollY = window.scrollY;

	const rootProps = currentButton.dataset.config ? JSON.parse(currentButton.dataset.config) : {}

	if (null === gravityForm) {
		return;
	}

	const fieldElement = currentButton.dataset.field ? gravityForm.querySelector<HTMLElement>(currentButton.dataset.field) : null
	activeField = currentButton.dataset.fieldWrapper ? gravityForm.querySelector<HTMLElement>(currentButton.dataset.fieldWrapper) : null

	const overlayElement = document.createElement("div")
	overlayElement.classList.add('gc-gform-overlay')
	overlayElement.style.display = 'block';

	const appElement = document.createElement("div")
	appElement.classList.add('gc-gform-overlay__app')
	overlayElement.appendChild(appElement)

	let partpickersBody = gravityForm.querySelector('.partpickers_body')

	if (!partpickersBody) {
		partpickersBody = gravityForm.querySelector('.gform_body')
	}

	partpickersBody?.appendChild(overlayElement)

	const setChoiceAndClosePicker = function(choiceValue: string) {
		const radioEl = fieldElement?.querySelector(`[value="${choiceValue}"]`) as HTMLInputElement | null

		if (radioEl) {
			radioEl.checked = true
			radioEl.dispatchEvent(new Event('change', { bubbles: true }));
			radioEl.classList.add('recently-checked')
		} else {
			console.log('radio el no found')
		}

		closePicker();
	}

	vueApp = createApp(GaragePartsCustomized, {closePicker, setChoiceAndClosePicker, ...rootProps})
	vueApp.mount(appElement)

	const recentlyCheckedFields = fieldElement?.querySelectorAll(`.recently-checked`)

	if (recentlyCheckedFields) {
		for (var i = 0; i < recentlyCheckedFields.length; i++) {
			const recentlyCheckedField = recentlyCheckedFields[i]

			recentlyCheckedField.classList.remove('recently-checked')
		}
	}

	scrollIntoViewWithAdminBarOffsetIfNeeded(overlayElement);
}

function initGravityFormPickers() {
	gravityForm.addEventListener('click', function(event) {
		const target = event.target as HTMLElement | null;

		if (target && target.classList.contains('gc-garage-part-picker-button')) {
			currentButton = target;
			openPicker()
			return;
		}

		if (target && target.classList.contains('gc-gform-overlay__close-button')) {
			closePicker()
			return;
		}
	});
}

window.addEventListener('DOMContentLoaded', function() {
	const gravityForms = document.querySelectorAll<HTMLElement>('.gc-garage-part-picker-form__gform .gform_wrapper')

	if (!gravityForms.length) {
		return;
	}

	gravityForm = gravityForms[0]

	initGravityFormPickers();
})
